import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%",
    "min-height": "50vh"
  }
};
const _hoisted_2 = {
  class: "search-container"
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';

import { ref, watch, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInfoDialog',
  props: {
    title: {},
    defaultSelect: {},
    tabelColunm: {},
    searchItems: {},
    url: {},
    tabelkey: {}
  },
  emits: ['select'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const dialog = useCommonDialog('userDialog');
    let searchForm = null;
    let table = null;
    const searchFormRef = ref();
    const tableRef = ref();
    watch(() => props.defaultSelect, () => {
      if (table) {
        initSysSelect();
      }
    }, {
      immediate: true
    });
    function open() {
      dialog.open();
      if (!table || !searchForm) {
        nextTick(() => {
          renderSearchForm();
          renderTable();
        });
      } else {
        initSysSelect();
      }
    }
    function close() {
      dialog.close();
    }
    /**
     * 绘制搜索表单
     */
    function renderSearchForm() {
      searchForm = new SearchForm(searchFormRef.value, props.searchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = formData => {
        table?.load(formData);
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, props.tabelColunm, [], {
        border: true,
        rowKey: 'id'
      }, props.url);
      table.onLoaded = () => {
        nextTick(() => {
          initSysSelect();
        });
      };
    }
    function initSysSelect() {
      if (props.defaultSelect) {
        table?.setSelectRowKeys(props.defaultSelect, props.tabelkey);
      }
    }
    function confirm() {
      const selectRows = table?.getSelectRows() || [];
      emits('select', selectRows);
      close();
    }
    function cancel() {
      close();
    }
    __expose({
      open,
      close
    });
    return (_ctx, _cache) => {
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      const _component_ElButton = _resolveComponent("ElButton");
      const _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "userDialog",
        title: _ctx.title,
        width: "70%"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_ElButton, {
          onClick: cancel
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_ElButton, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("确认")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_XFlexCtx, {
          flex: 1
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
            ref_key: "searchFormRef",
            ref: searchFormRef
          }, null, 512), _createVNode(_component_XFlexCtx, {
            flex: 1
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "height": "100%"
              },
              ref_key: "tableRef",
              ref: tableRef
            }, null, 512)]),
            _: 1
          })])]),
          _: 1
        })])]),
        _: 1
      }, 8, ["title"])]);
    };
  }
});